// Top level collections
export const WORKSPACE_USERS = 'workspaceUsers';
export const TEAMS = 'teams';
export const GOALS = 'goals';
export const WORKSPACES = 'workspaces';
export const INVITATIONS = 'invitations';
export const STANDUPS = 'standups';
export const SUBSCRIPTIONS = 'subscriptions';

// Subcollections
export const USERS = 'users'; // Found under WORKSPACE_USERS
